import { customTheme } from 'theme';

export const metaAccordionStyles = {
  item: {
    my: 0,
    px: 0,
    pb: 4,
    border: 'none',
    borderColor: 'componentBorder',
    borderRadius: 6,
  },
  innerWrapper: {
    border: '1px solid',
    borderColor: customTheme.colors.gray['100'],
    borderRadius: 6,
    py: 0,
    h: 'full',
  },
  button: {
    px: 3,
    _focus: { border: 'none' },
    _hover: { bg: 'transparent' },
  },
};
